import { render } from "./DetailsPlaza.vue?vue&type=template&id=30996f2d"
import script from "./DetailsPlaza.vue?vue&type=script&lang=js"
export * from "./DetailsPlaza.vue?vue&type=script&lang=js"

import "./DetailsPlaza.vue?vue&type=style&index=0&id=30996f2d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__